/**
 * Adds HTML content to a JsPDF document.
 *
 * @param {jsPDF} doc - The JsPDF document object.
 * @param {HTMLElement} html - The HTML content to be added.
 * @param {HTMLOptions} options - Additional options for the html method.
 *
 * @returns {Promise<jsPDF>} - A promise that resolves with the modified JsPDF document object.
 */
export default function addHtmlToJsPDF(doc, html, options) {
  return new Promise((resolve) => {
    doc.html(html, Object.assign({}, options, {
      callback: function (doc) {
        resolve(doc)
      }
    }))
  })
}